import { InjectionToken } from '@angular/core';
import { API } from 'projects/sharing/general/configs/api.config';
import { environment } from 'projects/sharing/environments/environment';

export interface MenuActionHeaderRule {
  pagePaths?: string[];
  endpointPaths: string[];
  menuId: string;
  actionId: string;
}

export const MENU_ACTION_HEADER_FALLBACK = '-';

const AUTH_PAGE_PATHS = [
  '/auth/login',
  '/auth/forgot_password',
  '/auth/reset_password',
  '/auth/change_password',
  '/auth/update-password',
  '/auth/register_member',
  '/auth/link_expired',
];

const PROFILE_PAGE_PATHS = ['/profile-and-account-settings'];

export const DEFAULT_MENU_ACTION_HEADER_CONFIG: MenuActionHeaderRule[] = [
  {
    pagePaths: AUTH_PAGE_PATHS,
    endpointPaths: [
      API.LOGIN,
      API.LOGIN_MFA,
      API.SEND_EMAIL,
      API.RESET_PASSWORD,
      API.RESET_PASSWORD_90_DAYS,
      API.CHECK,
      API.MENU_LIST_SIDEBAR,
      API.MERCHANT_GET,
      API.MEMBER_REGISTER,
      API.MEMBER_GET_USER_PROFILE,
      API.USERS_LOGOUT,
    ],
    menuId: environment.LOGIN_MENU_ID,
    actionId: environment.LOGIN_ACTION_ID,
  },
  {
    endpointPaths: [API.USERS_LOGOUT],
    menuId: environment.LOGOUT_MENU_ID,
    actionId: environment.LOGOUT_ACTION_ID,
  },
  {
    pagePaths: PROFILE_PAGE_PATHS,
    endpointPaths: [
      API.USER_SETTINGS_GET_USER_PROFILE,
      API.USER_SETTINGS_GET_LOGIN_SESSIONS,
      API.USER_SETTINGS_UPDATE_PROFILE_DETAILS,
      API.SEND_EMAIL,
      API.USER_SETTINGS_LOGOUT_BY_IDS,
      API.USER_SETTINGS_SEND_OTP,
      API.USER_SETTINGS_VERIFY_OTP,
      API.USER_SETTINGS_CHANGE_EMAIL,
      API.USER_SETTINGS_CHANGE_PASSWORD,
      API.USER_SETTINGS_MFA_VERIFY,
      API.CHECK,
    ],
    menuId: environment.PROFILE_AND_ACCOUNT_SETTINGS_MENU_ID,
    actionId: environment.PROFILE_AND_ACCOUNT_SETTINGS_ACTION_ID,
  },
];

export const MENU_ACTION_HEADER_CONFIG = new InjectionToken<
  MenuActionHeaderRule[]
>('MENU_ACTION_HEADER_CONFIG', {
  providedIn: 'root',
  factory: () => DEFAULT_MENU_ACTION_HEADER_CONFIG,
});
